import { MyOrganizationState } from "@organizations/models";
import { ActionReducerMap, createFeatureSelector } from "@ngrx/store";
import { reducer as invitationsReducer } from "@organizations/store/reducers/invitation.reducer";
import { reducer as locationsReducer } from "@organizations/store/reducers/location.reducer";
import { reducer as organizationAssignableRoleReducer } from "@organizations/store/reducers/organization-assignable-role.reducer";
import { reducer as organizationAssociatedProductReducer } from "@organizations/store/reducers/organization-associated-product.reducer";
import { reducer as organizationIssuerReducer } from "@organizations/store/reducers/organization-issuer.reducer";
import { reducer as organizationsReducer } from "@organizations/store/reducers/organization.reducer";
import { reducer as ousReducer } from "@organizations/store/reducers/ou.reducer";
import { reducer as productsReducer } from "@organizations/store/reducers/product.reducer";
import { reducer as roleAssignmentsReducer } from "@organizations/store/reducers/role-assignment.reducer";

export const reducers: ActionReducerMap<MyOrganizationState> = {
  invitations: invitationsReducer,
  locations: locationsReducer,
  organizationAssignableRoles: organizationAssignableRoleReducer,
  organizationAssociatedProducts: organizationAssociatedProductReducer,
  organizationIssuers: organizationIssuerReducer,
  organizations: organizationsReducer,
  ous: ousReducer,
  products: productsReducer,
  roleAssignments: roleAssignmentsReducer
};

export const selectMyOrganizationsState =
  createFeatureSelector<MyOrganizationState>("my-organizations");

export * as invitationsReducer from "@organizations/store/reducers/invitation.reducer";
export * as locationsReducer from "@organizations/store/reducers/location.reducer";
export * as organizationAssignableRoleReducer from "@organizations/store/reducers/organization-assignable-role.reducer";
export * as organizationAssociatedProductReducer from "@organizations/store/reducers/organization-associated-product.reducer";
export * as organizationIssuerReducer from "@organizations/store/reducers/organization-issuer.reducer";
export * as organizationsReducer from "@organizations/store/reducers/organization.reducer";
export * as ousReducer from "@organizations/store/reducers/ou.reducer";
export * as productsReducer from "@organizations/store/reducers/product.reducer";
export * as roleAssignmentsReducer from "@organizations/store/reducers/role-assignment.reducer";
